import { render, staticRenderFns } from "./ChatConversationItem.vue?vue&type=template&id=62857850&scoped=true"
import script from "./ChatConversationItem.vue?vue&type=script&lang=js"
export * from "./ChatConversationItem.vue?vue&type=script&lang=js"
import style0 from "./ChatConversationItem.vue?vue&type=style&index=0&id=62857850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62857850",
  null
  
)

export default component.exports